<template>
    <tr>
        <td>{{this.index + 1}}</td>
        <td>
          <vk-icon v-if="member.notes !== '' && member.notes !== null" icon="info" ratio="1" v-vk-tooltip.bottom="member.notes"></vk-icon>
        </td>
        <td><router-link :to="'/administration/members/' + this.member.bookNum.trim() + '/info'">{{ member.fName }}</br>{{ member.lName }}</router-link></td>
        <td><router-link :to="'/administration/members/' + this.member.bookNum.trim() + '/info'">{{ member.bookNum.trim() }}</router-link></td>
        <td class="noWrap">{{member.phoneNumber}}</td>
        <td>{{formatDate(member.registeredDate)}}</td>
        <td >
          <ul class="uk-align-center uk-margin-remove">
            <li v-if="expired && member.expirationDate !== null">
              <vk-icon :class="(expired) ? 'error' : ''" icon="warning" ratio="1" v-vk-tooltip.bottom="member.notes"></vk-icon>
            </li>
            <li :class="(expired) ? 'error uk-text-bold' : ''">{{(member.expirationDate === null) ? "" : formatExpDate(member.expirationDate)}}</li>
          </ul>
        </td>
        <td>
          <ul>
            <li v-for="(classification, i) in member.classifications" v-bind:key="i">{{classification}}</li>
          </ul>
        </td>
        <td>
          <ul>
            <li v-for="(certification, i) in member.certifications" v-bind:key="i">{{certification}}</li>
          </ul>
        </td>
        <td>
          <div class="uk-text-center" v-vk-tooltip.bottom="'Add Booking'">
            <vk-icon icon="copy" ratio="1"></vk-icon>
            <router-link :class="(this.member.booked) ? 'uk-badge booked' : 'uk-badge'" :to="'/administration/associations/bookings/create?booknum=' + this.member.bookNum.trim()">{{member.bookings.length}}</router-link>
          </div>
        </td>
        <td>
          <div class="uk-text-center" v-vk-tooltip.bottom="'Add Refusal'">
            <vk-icon icon="ban" ratio="1"></vk-icon>
            <router-link class="uk-badge" :to="'/administration/associations/refusals/create?booknum=' + this.member.bookNum.trim()">{{member.refusals.length}}</router-link>
          </div>
        </td>
        <td>
          <div class="uk-text-center" v-vk-tooltip.bottom="'Add Absentee'">
            <vk-icon icon="question" ratio="1"></vk-icon>
            <router-link class="uk-badge" :to="'/administration/associations/absences/create?booknum=' + this.member.bookNum.trim()">{{member.absences.length}}</router-link>
          </div>
        </td>
        <td>
          <div class="uk-text-center" v-vk-tooltip.bottom="'Add Remark'">
            <vk-icon icon="comments" ratio="1"></vk-icon>
            <router-link class="uk-badge" :to="'/administration/associations/remarks/create?booknum=' + this.member.bookNum.trim()">{{member.remarks.length}}</router-link>
          </div>
        </td>
        <td>
          <a class="uk-align-center"><vk-icon icon="more-vertical" ratio="1" v-vk-tooltip.top="'More Actions'"></vk-icon></a>
          <vk-drop mode="click" position="bottom-center">
            <vk-card>
              <router-link class="uk-margin-small-right" :to="'/administration/members/' + this.member.bookNum.trim() + '/edit/'" v-vk-tooltip.bottom="'Edit Member'"><vk-icon icon="pencil" ratio="1"></vk-icon></router-link>
              <a class="uk-margin-small-right" v-on:click="showResetModal = true"><vk-icon icon="refresh" ratio="1" v-vk-tooltip.bottom="'Reset Member'"></vk-icon></a>
              <a v-vk-tooltip.bottom="'Delete Member'"><vk-icon icon="minus-circle" ratio="1" v-on:click="showDeleteModal = true"></vk-icon></a>
            </vk-card>
          </vk-drop>
        </td>
        <vk-modal :show.sync="showResetModal">
          <vk-modal-title>Are you sure you want to reset {{member.fName + " " + member.lName}}?</vk-modal-title>
          <p class="uk-text-right">
            <vk-button @click="showResetModal = false" class="uk-margin-small-right">Cancel</vk-button>
            <vk-button type="primary" @click="resetMember">Reset</vk-button>
          </p>
        </vk-modal>
        <vk-modal :show.sync="showDeleteModal">
          <vk-modal-title>Are you sure you want to delete {{member.fName + " " + member.lName}}?</vk-modal-title>
          <p class="uk-text-right">
            <vk-button @click="showDeleteModal = false" class="uk-margin-small-right">Cancel</vk-button>
            <vk-button type="primary" @click="deleteMember">Delete</vk-button>
          </p>
        </vk-modal>
    </tr>
</template>

<script>
import MembersApi from "@/utils/api/members";

export default {
  name: "table-row",
  props: {
    member: null,
    index: 0
  },
  data() {
    return {
      showResetModal: false,
      showDeleteModal: false,
      expired: false
    };
  },
  created() {
    this.expired =
      this.dateDiffInDays(new Date(), new Date(this.member.expirationDate)) < 10
        ? true
        : false;
  },
  updated() {
    this.expired =
      this.dateDiffInDays(new Date(), new Date(this.member.expirationDate)) < 10
        ? true
        : false;
  },
  methods: {
    dateDiffInDays(a, b) {
      const _MS_PER_DAY = 1000 * 60 * 60 * 24;
      // Discard the time and time-zone information.

      return Math.floor((b - a) / _MS_PER_DAY);
    },
    formatDate(date) {
      var d = new Date(date);
      return d.toLocaleDateString("en-US", {
        month: "numeric",
        day: "numeric",
        year: "2-digit",
        hour: "numeric",
        minute: "numeric"
      });
    },
    formatExpDate(date) {
      var d = new Date(date);
      return d.toLocaleDateString("en-US", {
        month: "numeric",
        day: "numeric",
        year: "2-digit"
      });
    },
    resetMember() {
      MembersApi.resetMember(
        this.$cookie.get("iwl_apiToken"),
        this.member.bookNum.trim()
      )
        .then(member => {
          this.showResetModal = false;
          this.$emit("refresh");
        })
        .catch(error => console.log(error));
    },
    deleteMember() {
      MembersApi.deleteMember(
        this.$cookie.get("iwl_apiToken"),
        this.member.bookNum.trim()
      )
        .then(member => {
          this.showDeleteModal = false;
          this.$emit("refresh");
        })
        .catch(error => console.log(error));
    },
    goToInfo() {
      this.$router.push(
        "/administration/members/" + this.member.bookNum.trim() + "/info"
      );
    }
  }
};
</script>

<style scoped>
ul {
  padding: 0px;
}
li {
  list-style: none;
}
tr:nth-child(even) {
  background-color: #f2f2f2;
}
td {
  vertical-align: middle;
}
.uk-text-center {
  position: relative;
}
.uk-badge {
  position: absolute;
  top: -10px;
  margin-left: -10px;
}
.booked {
  background: green;
}
.uk-align-center {
  margin-bottom: 0px;
  text-align: center;
}
.noWrap {
  white-space: nowrap;
}
</style>





// WEBPACK FOOTER //
// src/components/admin_queue_row.vue